module.exports = __webpack_public_path__ + "img/arrow-up-left-square-fill.c3c470b4.svg";